import React from 'react';
import { useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import { getUserData } from '../../selectors/user';
import { trackMixpanelEvent } from '../../utils/general';
import TopbarMenu from './TopbarMenu';
import { isFreeTierOrTrial, isStandardUnified } from '../utils';
import { HEADERS } from '../consts';
import css from '../style.css';

const track = name => trackMixpanelEvent('Top', `${name} clicked`);

function HelpMenu() {
    const userData = useSelector(getUserData) || {};
    const freeOrTrial = isFreeTierOrTrial(userData);
    const standardUnified = isStandardUnified(userData);

    return (
        <TopbarMenu
            ariaLabel="help menu"
            toggle={
                <>
                    <Icon name="help" size={IconSizes.SMALL} variant={IconVariants.WHITE} />
                    <Translate id={`${HEADERS}.HELP`} />
                </>
            }
        >
            {!freeOrTrial && (
                <a
                    className={css.menuItem}
                    href="https://support.singular.net/hc/en-us/requests/new"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => track('Support Form')}
                >
                    <Translate id={standardUnified ? `${HEADERS}.OPEN_A_TICKET` : `${HEADERS}.CONTACT_US`} />
                    <Icon name="external-link" size={IconSizes.X_SMALL} />
                </a>
            )}
            <a
                className={css.menuItem}
                href="https://support.singular.net/hc/"
                target="_blank"
                rel="noreferrer"
                onClick={() => track('Help Center Link')}
            >
                <Translate id={`${HEADERS}.HELP_CENTER`} />
                <Icon name="external-link" size={IconSizes.X_SMALL} />
            </a>
            {(freeOrTrial || standardUnified) && (
                <button type="button" className={css.menuItem} onClick={() => track('Ask a question Link')}>
                    <Translate id={`${HEADERS}.ASK_A_QUESTION`} />
                </button>
            )}
        </TopbarMenu>
    );
}

export default HelpMenu;
